import { ScenarioWellShutInBase } from './base/scenario-well-shut-in-base';

export class ScenarioWellShutIn extends ScenarioWellShutInBase { }